import React, { useRef, useEffect, useContext } from "react";
import { CommonService, PendoService } from "@services";
import { ConfigurationContext } from "../../../contexts/Configuration";
import { SearchContext } from "../../../contexts/Search";
import { processDynamicPlaceholders } from "./DynamicPlaceholderUtil";

const DynamicHtml = ({
  input,
  resultname,
  className,
  part,
  type,
  channelName,
  hierarchyShortName,
  stateName,
  zipCode,
  dynamicPlaceholders = {},
  ignorePlaceholders,
}) => {
  const { appliedConfiguration } = useContext(ConfigurationContext);
  const { searchTermDisplay, benefitType, productId, productName } = useContext(SearchContext);

  input = String(input);

  if (typeof part === "undefined" || part === "") {
    part = "cfDivHeaderText";
  }
  input = CommonService.htmlDecode(input ?? "");

  const generalSetting = appliedConfiguration?.coverageFinderConfiguration ?? appliedConfiguration?.generalSetting;
  const indicationName = generalSetting?.indicationName ?? appliedConfiguration.indicationName;

  if (!ignorePlaceholders) {
    // Process dynamic placeholders using utility function
    input = processDynamicPlaceholders(input, {
      appliedConfiguration,
      resultname,
      channelName,
      hierarchyShortName,
      stateName,
      searchTermDisplay,
      benefitType,
      indicationName,
      dynamicPlaceholders,
      zipCode
    });

    if (input != null) {
      input = CommonService.replaceDatePlaceholders(input);
    }
  }

  input = CommonService.encodeAngleBrackets(input);

  const ref = useRef(null);

  if (className == "norstella-cf-prescriberNoteSection") {
    input = `<h3 tabIndex="0" style="margin:0px" class="norstella-cf-prescriberNoteSection">${input}</h3>`;
  }
  useEffect(() => {
    const handleClick = (event) => {
      let target = event.target;
      if (target.tagName === "IMG" && target.parentElement.tagName === "A") {
        target = target.parentElement;
      }
      if (target.tagName === "A") {
        const title = target.textContent;
        //pendo track event
        PendoService.getInstance().trackEvent(
          title + " Url",
          title.includes("PA Form") ? "prescriberNotes/openPAForms" : "prescriberNotes/openPolicyLink",
          target.href,
          productId,
          productName,
          indicationName
        );
        // Open the link in a new tab
        window.open(target.href, "_blank", "noopener,noreferrer");
        event.preventDefault(); // Prevent default if you are handling the opening
      }
    };

    const node = ref.current;
    if (node) {
      node.addEventListener("click", handleClick);
    }

    return () => {
      if (node) {
        node.removeEventListener("click", handleClick);
      }
    };
  }, []);

  if (CommonService.isUrl(input)) {
    return (
      <div>
        <a className="norstella-cf-href" target="_blank" rel="noreferrer" href={input} ref={ref}>
          PA & Step Therapy Comprehensive Policy-1
        </a>
      </div>
    );
  }
  if (input && input.trim() !== "") {
    switch (type) {
      case "label":
        return <label className={className} part={part} dangerouslySetInnerHTML={{ __html: CommonService.sanitizeHTML(input) }} ref={ref} />;
      default:
        // Default case if type doesn't match any specific control
        return <div className={className} part={part} dangerouslySetInnerHTML={{ __html: CommonService.sanitizeHTML(input) }} ref={ref} />;
    }
  }
};

export default DynamicHtml;